// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"4f98c3bb","751":"88ca6b1c","777":"41bbfccf"}[chunkId] + ".chunk.css";
};